import { GALLERY } from "../data/cafe";

// Bento sizes
const sizes = [
  "md:col-span-2 md:row-span-2",
  "md:col-span-1 md:row-span-1",
  "md:col-span-1 md:row-span-2",
  "md:col-span-2 md:row-span-1",
  "md:col-span-1 md:row-span-1",
  "md:col-span-2 md:row-span-2",
  "md:col-span-1 md:row-span-1",
  "md:col-span-1 md:row-span-1",
];

export default function Gallery() {
  return (
    <div data-testid="page-gallery" className="pt-32 pb-20">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <span className="text-xs uppercase tracking-[0.4em] text-[#FF8C5A]">
          Gallery
        </span>
        <h1 className="font-display text-5xl md:text-7xl mt-4">
          A look inside <span className="italic text-gradient">the chill.</span>
        </h1>
        <p className="text-white/60 mt-6 max-w-2xl text-lg">
          A few frames from our corner of the city. Drop in to see the rest.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-4 md:auto-rows-[200px] gap-4 mt-16">
          {GALLERY.map((img, i) => (
            <div
              key={img.url}
              data-testid={`gallery-image-${i}`}
              className={`relative overflow-hidden rounded-2xl group ${sizes[i] || ""}`}
            >
              <img
                src={img.url}
                alt={img.alt}
                className="w-full h-full object-cover min-h-[220px] group-hover:scale-105 transition duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition" />
            </div>
          ))}
        </div>

        <div className="mt-20 p-8 md:p-12 rounded-3xl border border-white/10 bg-[#0a0a0a] text-center">
          <h3 className="font-display text-2xl md:text-3xl">
            Tag us when you visit — <span className="text-gradient">@mismos</span>
          </h3>
          <p className="text-white/50 mt-3">
            We feature our favourites every week.
          </p>
        </div>
      </div>
    </div>
  );
}
